
import { MapLayer, IDeckGlLayer } from './MapLayer';
import GeoJsonNodeLayer from './GeoJsonNodeLayer';

export class SoilProfileMapLayer extends MapLayer implements IDeckGlLayer {
    _source: any;
    _errorMessage: string | null;
    _renderConfig: {};
    _hoverSoilProfileIndex: number | null;

    constructor(id: string, name: string, visible: boolean, source: any, renderConfig: {}, hoverSoilProfileIndex:number | null) {
        super(id, name, visible);
        this._source = source;
        this._errorMessage = null;
        this._renderConfig = renderConfig;
        this._hoverSoilProfileIndex = hoverSoilProfileIndex;
    }

    public async syncWithAwaited(): Promise<boolean> {
        return true;
    }

    public async load(): Promise<boolean> {
        return true;
    }

    public hasError(): boolean {
        return this._errorMessage !== null;
    }

    public getError(): string {
        return this._errorMessage ? this._errorMessage : '';
    }

    dataLoaded(): boolean {
        return true;
    }

    public getColorRamp(): string | null {
        return null;
    }

    getDescForObject(object: any): string {
        return object && `Push #${object.properties.name}`;
    }

    public getDeckGlLayer(zoom: number) {
        return new GeoJsonNodeLayer({
            id: this.id,
            data: this._source.features,
            pickable: true,
            getPosition: (d:any) => d.geometry.coordinates,
            highlightedObjectIndex: this._hoverSoilProfileIndex,

            radiusScale: 1,
            getRadius: 5,
            getRadiusMinPixels: 5,
            getRadiusMaxPixels: 25,
            getFillColor: [0,0,0], // Push point fill color (map color)
            getHoverColor: [255, 255, 255],

            getText: (d:any) => `${d.properties.name ? d.properties.name : ""}`,
            getTextSize: zoom*0.75,
            getTextColor: [255, 255, 255], 
            getTextVisible: zoom > 16.5,
            getFontFamily: "'Roboto', sans-serif",
            getHoverTextColor: [0, 0, 0],
            antialiasing:true,
        });
    }
}
